import { Facade } from "../../facades/facade";
import { Observable } from "rxjs/Observable";
import { VasStore } from "../../../vas/store/store-type";
import { IAppFacade } from "../../services/app-facade/app-facade.interface";

export abstract class StoreFacade extends Facade {

    constructor(protected appFacade: IAppFacade, protected storeService: VasStore) {
        super(appFacade);
    }

    protected dispatch(action): void {
        this.storeService.dispatch(action);
    }

    protected select<R>(query): Observable<R> {
        return this.storeService.select(query);
    }
}



// WEBPACK FOOTER //
// ./src/core/store/facade/store-facade.ts